module.exports = __webpack_public_path__ + "static/media/py.21ea2626.svg";